import Hero from "@/components/Hero";
import { FAQSection, GallerySection, ServicesGrid, Testimonials } from "@/components/Showcase";
import { CTABanner, FinalCTA, ProcessSteps, StatsRow, WhyUs } from "@/components/Marketing";
import { Overline, Reveal } from "@/components/Reveal";
import { SEO } from "@/components/SEO";
import { MapPin } from "lucide-react";

const AreaPage = ({ area }) => (
  <>
    <SEO title={area.metaTitle} description={area.metaDesc} />
    <Hero
      overline={`${area.name}, Alabama · ${area.county}`}
      lines={[
        { text: `${area.name}'s Remodeling` },
        { text: "Craftsmen.", accent: true },
      ]}
      sub={`Bathroom remodeling, kitchen remodeling, and tile & wood flooring for ${area.name} homeowners — free in-home estimates, written pricing, and a 2-year workmanship warranty.`}
      bullets={[
        `Serving all of ${area.county}`,
        "Free in-home estimates",
        "Licensed & fully insured",
        "2-year workmanship warranty",
      ]}
      image={area.heroImage}
      imageAlt={`Home remodeling in ${area.name}, Alabama`}
      formTitle={`Free Estimate in ${area.name}`}
      formSource={`area-${area.slug}-hero`}
      idPrefix="area-hero"
    />
    <StatsRow />

    <section className="bg-white py-16 md:py-24" data-testid="area-neighborhoods-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <Overline>Neighborhoods We Serve</Overline>
          <h1 className="mt-3 max-w-3xl font-serif text-2xl font-bold tracking-tight text-navy sm:text-3xl lg:text-4xl">
            Home Remodeling in {area.name}, AL
          </h1>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-slate-600">{area.intro}</p>
        </Reveal>
        <Reveal delay={0.1} className="mt-8 flex flex-wrap gap-3">
          {area.neighborhoods.map((n) => (
            <span
              key={n}
              data-testid={`neighborhood-chip-${n.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="flex items-center gap-1.5 rounded-full border border-slate-200 bg-cream px-4 py-2 text-sm font-medium text-navy"
            >
              <MapPin className="h-3.5 w-3.5 text-salmon" /> {n}
            </span>
          ))}
        </Reveal>
      </div>
    </section>

    <ServicesGrid heading={`Remodeling Services in ${area.name}, AL`} />
    <CTABanner title={`Planning a remodel in ${area.name}?`} />
    <WhyUs title={`Why ${area.name} Homeowners Choose Gregory Tile`} />
    <ProcessSteps />
    <GallerySection heading={`Recent Projects Near ${area.name}`} />
    <Testimonials />
    <FAQSection faqs={area.faqs} heading={`${area.name} Remodeling FAQs`} />
    <FinalCTA heading={`Get Your Free ${area.name} Estimate`} />
  </>
);

export default AreaPage;
